export const FETCH_SHIFT = 'views/users/FETCH_SHIFT'